export default "__VITE_ASSET__nnHd5xFZXImkhSjNC3eMGg__"